import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWachtwoordWijzigen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FED27A"
      d="M29.63 13.33h-1.88v-3c0-3.87-3.13-7-7-7s-7 3.13-7 7h3c0-2.21 1.79-4 4-4s4 1.79 4 4v3H11.87c-.62 0-1.12.5-1.12 1.12V30.2c0 .62.5 1.12 1.12 1.12h17.75c.62 0 1.12-.5 1.12-1.12V14.45c0-.62-.5-1.12-1.12-1.12z"
    />
    <path
      fill="#F18700"
      d="M23.75 20.33c0-1.66-1.34-3-3-3s-3 1.34-3 3c0 1.2.7 2.22 1.72 2.7l-.72 4.3h4l-.72-4.3a3 3 0 0 0 1.72-2.7"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWachtwoordWijzigen);

export default ForwardRef;
